import { yup } from '@guiker/yup-util'

export const listingIdSchema = yup.object({
  listingId: yup.string().required(),
})
